<template>
    <pro-link
        v-if="isRelative"
        :to="{
            name: 'handbook-product-all',
            params: { product: currentProduct.slug, pathMatch: requiredVersion + url.pathname.substr(1) },
            query: Object.fromEntries(url.searchParams),
            hash: hash,
        }"
    >
        <slot />
    </pro-link>
    <pro-link v-else :href="parsedHref">
        <slot />
    </pro-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            defaultVersion: "handbook/getDefaultVersion",
            currentVersion: "handbook/getCurrentVersion",
            currentProduct: "handbook/getCurrentProduct",
        }),
        requiredVersion() {
            if (this.currentVersion !== this.defaultVersion) {
                return this.currentVersion.slug + "/";
            }

            return "";
        },
        url() {
            return new URL(this.parsedHref, "http://unused");
        },
        hash() {
            if (this.url.hash.length > 0) {
                return this.url.hash;
            }
            return "";
        },
    },

    props: {
        href: String,
    },

    data: function () {
        return {
            parsedHref: this.href,
            isRelative: true,
        };
    },

    created() {
        if (this.href.startsWith("http")) {
            this.isRelative = false;
        } else {
            if (this.parsedHref.indexOf("/cn/handbook/") === 0) {
                this.parsedHref = this.parsedHref.replace("/cn/handbook/", "");
            }

            if (this.parsedHref.indexOf("/cn/") === 0) {
                this.parsedHref = this.parsedHref.replace("/cn/", "");
            }

            if (this.parsedHref.indexOf("/handbook/") === 0) {
                this.parsedHref = this.parsedHref.replace("/handbook/", "");
            }

            if (this.parsedHref.indexOf("/") === 0) {
                this.parsedHref = this.parsedHref.substring(1);
            }
        }
    },
};
</script>
